import { Cpu } from "lucide-react";

export const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="bg-[#F8FAFC] border-b border-[#E5E7EB]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-1.5 bg-white border border-[#E5E7EB] rounded-sm px-2.5 py-1 mb-4">
              <Cpu className="w-3.5 h-3.5 text-[#025979]" strokeWidth={1.5} />
              <span className="text-[11px] font-medium text-[#025979] tracking-wide">
                WarehouseX Platform
              </span>
            </div>
            <h1
              data-testid="hero-title"
              className="text-4xl sm:text-5xl font-bold tracking-tight text-[#111827] leading-[1.05]"
              style={{ fontFamily: 'Chivo, sans-serif' }}
            >
              WarehouseX SmartStrategy
            </h1>
            <p
              data-testid="hero-subtitle"
              className="mt-4 text-base sm:text-lg text-[#6B7280] leading-relaxed max-w-lg"
            >
              A structured system to evaluate your warehouse, identify improvement opportunities, and define a clear execution roadmap with measurable ROI.
            </p>
            <p
              data-testid="hero-support-text"
              className="mt-3 text-sm text-[#374151] max-w-lg"
            >
              Choose a module below to begin your warehouse transformation journey.
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-[#6B7280]">
              <span className="relative flex h-2 w-2">
                <span className="animate-pulse-subtle absolute inline-flex h-full w-full rounded-full bg-[#025979] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#025979]"></span>
              </span>
              <span>Three connected modules — Evaluate, Improve, and Blueprint.</span>
            </div>
          </div>
          <div className="relative hidden lg:block">
            <div className="border border-[#E5E7EB] rounded-sm overflow-hidden relative shadow-sm">
              <img loading="eager" fetchpriority="high"
                src="/images/smartsuite-main.webp"
                alt="Modern warehouse with team reviewing analytics, AMR robots and flow arrows on the floor"
                className="w-full h-auto object-cover aspect-[16/9]"
                data-testid="hero-image"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#025979]/15 to-transparent pointer-events-none"></div>
            </div>
            <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm border border-[#025979]/20 rounded-sm px-2.5 py-1 flex items-center gap-1.5">
              <Cpu className="w-3.5 h-3.5 text-[#025979]" strokeWidth={1.5} />
              <span className="text-xs font-medium text-[#025979]">AI Powered</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
